import { render } from "./Footer.vue?vue&type=template&id=284147f6&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=284147f6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-284147f6"

export default script